import React, { useEffect, useState } from 'react';
import './CombatResultModal.css';

function CombatResultModal({ resultado, rewards, gender, onClose, onRematch }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => setShow(true), 100);
  }, []);

  const getResultImage = () => {
    const suffix = gender === 'F' ? 'woman' : '';
    const images = {
      victoria: `/assets/menu/victoria${suffix}.png`,
      derrota: `/assets/menu/derrota${suffix}.png`,
      empate: `/assets/menu/empate${suffix}.png`
    };
    return images[resultado] || images.victoria;
  };

  const getResultTitle = () => {
    return {
      victoria: '¡VICTORIA!',
      derrota: '¡DERROTA!',
      empate: '¡EMPATE!'
    }[resultado] || '¡VICTORIA!';
  };

  const getResultColor = () => {
    return {
      victoria: '#FFD700',
      derrota: '#FF4444',
      empate: '#FFA500'
    }[resultado] || '#FFD700';
  };

  return (
    <div className={`combat-result-overlay ${show ? 'show' : ''}`}>
      <div className={`combat-result-modal ${show ? 'show' : ''}`}>
        <div className="result-image-container">
          <img 
            src={getResultImage()} 
            alt={resultado}
            className="result-image"
            onError={(e) => e.target.style.display = 'none'}
          />
        </div>

        <h1 className="result-title" style={{ color: getResultColor() }}>
          {getResultTitle()}
        </h1>

        <div className="result-xp">
          <span className="xp-icon">⚡</span>
          <span className="xp-value">+{rewards?.xp || 0} XP</span>
        </div>

        <div className="result-buttons">
          <button className="btn-rematch" onClick={onRematch}>
            🔄 REVANCHA
          </button>
          <button className="btn-menu" onClick={onClose}>
            🏠 MENÚ
          </button>
        </div>
      </div>
    </div>
  );
}

export default CombatResultModal;
